/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateTrackResponse
 */
export interface CreateTrackResponse {
    /**
     * The blockchain transaction hash
     * @type {string}
     * @memberof CreateTrackResponse
     */
    transactionHash?: string;
    /**
     * The blockchain block hash
     * @type {string}
     * @memberof CreateTrackResponse
     */
    blockHash?: string;
    /**
     * The blockchain block number/height
     * @type {number}
     * @memberof CreateTrackResponse
     */
    blockNumber?: number;
    /**
     * The ID of the created track
     * @type {string}
     * @memberof CreateTrackResponse
     */
    trackId?: string;
}

/**
 * Check if a given object implements the CreateTrackResponse interface.
 */
export function instanceOfCreateTrackResponse(value: object): value is CreateTrackResponse {
    let isInstance = true;

    return isInstance;
}

export function CreateTrackResponseFromJSON(json: any): CreateTrackResponse {
    return CreateTrackResponseFromJSONTyped(json, false);
}

export function CreateTrackResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateTrackResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'transactionHash': !exists(json, 'transaction_hash') ? undefined : json['transaction_hash'],
        'blockHash': !exists(json, 'block_hash') ? undefined : json['block_hash'],
        'blockNumber': !exists(json, 'block_number') ? undefined : json['block_number'],
        'trackId': !exists(json, 'track_id') ? undefined : json['track_id'],
    };
}

export function CreateTrackResponseToJSON(value?: CreateTrackResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'transaction_hash': value.transactionHash,
        'block_hash': value.blockHash,
        'block_number': value.blockNumber,
        'track_id': value.trackId,
    };
}

